export default class GroupPolicy
{
    /**
     * Determine whether the user can view any models.
     *
     * @param  {object}  user
     * @return mixed
     */
    viewAny(user)
    {
        //
    }

    /**
     * Determine whether the user can view the model.
     *
     * @param  {object}  user
     * @param  {object}  group
     * @return {mixed}
     */
    view(user, group)
    {
        //
    }

    /**
     * Determine whether the user can create models.
     *
     * @param  {object}  user
     * @return {mixed}
     */
    create(user)
    {
        //
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  group
     * @return {mixed}
     */
    update(user, group)
    {
        //
    }

    /**
     * Determine whether the user can restore the model.
     *
     * @param  {object}  user
     * @param  {object}  group
     * @return {mixed}
     */
    restore(user, group)
    {
        //
    }

    /**
     * Determine whether the user can delete the model.
     *
     * @param  {object}  user
     * @param  {object}  group
     * @return {mixed}
     */
    delete(user, group)
    {
        //
    }

    /**
     * Determine whether the user can permanently delete the model.
     *
     * @param  {object}  user
     * @param  {object}  group
     * @return {mixed}
     */
    forceDelete(user, group)
    {
        //
    }
}
